import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const fetchAllLab = createAsyncThunk(
  "report/fetchAllLab",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.GET_ALL_LAB);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);
export const createLab = createAsyncThunk(
  "report/createLab",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_Lab,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const initialState = {
  Labs: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const LabSlice = createSlice({
  name: "Lab",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLab.pending, (state) => {
        state.Labs.loading = true;
        state.Labs.error = null;
      })
      .addCase(fetchAllLab.fulfilled, (state, action) => {
        state.Labs.loading = false;
        state.Labs.data = action.payload;
      })
      .addCase(fetchAllLab.rejected, (state, action) => {
        state.Labs.loading = false;
        state.Labs.error = action.payload;
      });
  },
});

export default LabSlice.reducer;
